import React, { FormEvent, useEffect, useState } from "react";
import { CenteredPageDiv } from "../../styles/global.styles";
import {
  CustomerButton,
  CustomerContentButton,
  CustomerForm,
  CustomerFormControl,
  CustomerInputLabel,
  CustomerOutlinedInput,
  TextH2,
} from "./styles";
import qs from "qs";
import { useParams } from "react-router-dom";
import { getUser, updateUser } from "../../Services/Admin";
import { ICustomer, ICustomerServicesUser } from "../../Services/Interfaces";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import { ModalB, ModalP } from "../Modal/Customer/styles";
import { DateFormat, cnpjMask } from "../../utils/conversions";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const CustomerEditComponent: React.FC = () => {
  const { customerID } = useParams();

  const [customer, setCustomer] = useState<ICustomer>({} as ICustomer);

  const [profileFullName, setProfileFullName] = useState<string>("");
  const [profileCpf, setProfileCpf] = useState<string>("");
  const [healthPlaceId, setHealthPlaceId] = useState<string>("");
  const [customerServiceLimitPerMonth, setCustomerServiceLimitPerMonth] =
    useState<string>("");
  const [userPassword, setUserPassword] = useState<string>("");
  const [customerServiceExpirationDate, setCustomerServiceExpirationDate] =
    useState<string>("");

  const [customerServices, setCustomerServices] = useState<
    ICustomerServicesUser[]
  >([]);

  const [valueAba, setValueAba] = useState(0);

  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    event.preventDefault();
    setValueAba(newValue);
    const cs = customerServices[newValue];
    setHealthPlaceId(cs.service.healthPlace.id);
    setCustomerServiceLimitPerMonth(cs.limitPerMonth);
    // ajustar expiration date para o customer service selecionado
    if (cs.expirationDate) {
      const d = new Date(cs.expirationDate);
      setCustomerServiceExpirationDate(d.toISOString().slice(0, 10));
    } else {
      setCustomerServiceExpirationDate("");
    }
  };

  useEffect(() => {
    if (customerID) {
      getUser(customerID)
        .then((response) => {
          if (response) {
            setCustomer(response);
          }
        })
        .catch((error) => console.error(error));
    }
  }, [customerID]);

  useEffect(() => {
    if (customer) {
      setProfileFullName(customer.profile?.fullName);
      setProfileCpf(customer.profile?.cpf);
      setCustomerServices(customer.customer?.customerServices);
      setHealthPlaceId(
        customer.customer?.customerServices[0].service.healthPlace.id
      );
      setCustomerServiceLimitPerMonth(
        customer.customer?.customerServices[0].limitPerMonth
      );
      // Preencher expirationDate se disponível
      const firstCS = customer.customer?.customerServices[0];
      if (firstCS && firstCS.expirationDate) {
        // assumir formato YYYY-MM-DD para input[type=date]
        const d = new Date(firstCS.expirationDate);
        const iso = d.toISOString().slice(0, 10);
        setCustomerServiceExpirationDate(iso);
      }
    }
  }, [customer]);

  const handleUpdate = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();

    const payload: any = {
      "update[profileFullName]": profileFullName,
      "update[profileCpf]": profileCpf,
      "update[healthPlaceId]": healthPlaceId,
      "update[customerServiceLimitPerMonth]": customerServiceLimitPerMonth,
    };

    // Incluir senha apenas se foi informada
    if (userPassword && userPassword.trim() !== "") {
      payload["update[user_password]"] = userPassword;
    }

    // Incluir expiration date do customer service apenas se fornecida
    if (
      customerServiceExpirationDate &&
      customerServiceExpirationDate.trim() !== ""
    ) {
      // input[type=date] fornece YYYY-MM-DD, backend precisa dd/mm/yyyy
      const parts = customerServiceExpirationDate.split("-");
      if (parts.length === 3) {
        const formatted = `${parts[2]}/${parts[1]}/${parts[0]}`;
        payload["update[customerservice_expirationdate]"] = formatted;
      } else {
        payload["update[customerservice_expirationdate]"] =
          customerServiceExpirationDate;
      }
    }

    updateUser(customer?.id, qs.stringify(payload)).catch((error) =>
      console.error(error)
    );
  };

  return (
    <CenteredPageDiv>
      <TextH2>Editar Cliente</TextH2>
      <br />
      <CustomerForm onSubmit={handleUpdate} autoComplete="off">
        {/* Hidden dummy fields to prevent browser autofill for password managers */}
        <div style={{ position: "absolute", left: -9999, top: -9999 }} aria-hidden>
          <input type="text" name="fake-username" autoComplete="username" tabIndex={-1} />
          <input type="password" name="fake-password" autoComplete="current-password" tabIndex={-1} />
        </div>
        <CustomerFormControl variant="outlined">
          <CustomerInputLabel htmlFor="profileFullName">
            Nome
          </CustomerInputLabel>
          <CustomerOutlinedInput
            value={profileFullName}
            onChange={(e) => setProfileFullName(e.target.value)}
            id="profileFullName"
            type="text"
            label="Nome"
          />
        </CustomerFormControl>
        <br />
        <br />
        <div style={{ display: "flex", gap: 12 }}>
          <CustomerFormControl variant="outlined" percentage="48%">
            <CustomerInputLabel htmlFor="profileCpf">CPF</CustomerInputLabel>
            <CustomerOutlinedInput
              value={profileCpf}
              onChange={(e) => setProfileCpf(e.target.value)}
              id="profileCpf"
              type="text"
              label="CPF"
            />
          </CustomerFormControl>

          <CustomerFormControl
            variant="outlined"
            percentage="48%"
          >
            <CustomerInputLabel htmlFor="services">
              Medições Contratadas
            </CustomerInputLabel>
            <CustomerOutlinedInput
              value={customerServiceLimitPerMonth}
              onChange={(e) => setCustomerServiceLimitPerMonth(e.target.value)}
              id="services"
              type="number"
              label="Medições Contratadas"
            />
          </CustomerFormControl>
        </div>

        <br />
        <br />

        <div style={{ display: "flex", gap: 12 }}>
          <CustomerFormControl
            variant="outlined"
            percentage="48%"
          >
            <CustomerInputLabel htmlFor="expirationDate">
              Data de Expiração
            </CustomerInputLabel>
            <CustomerOutlinedInput
              value={customerServiceExpirationDate}
              onChange={(e) => setCustomerServiceExpirationDate(e.target.value)}
              id="expirationDate"
              type="date"
              label="Data de Expiração"
              style={{ height: 56 }}
              inputProps={{
                style: { padding: "10px 14px", boxSizing: "border-box" },
              }}
            />
          </CustomerFormControl>

          <CustomerFormControl variant="outlined" percentage="48%">
            <CustomerInputLabel htmlFor="userPassword">
              Senha (opcional)
            </CustomerInputLabel>
            <CustomerOutlinedInput
              value={userPassword}
              onChange={(e) => setUserPassword(e.target.value)}
              id="userPassword"
              type="password"
              label="Senha"
              autoComplete="new-password"
              inputProps={{ name: "new-password", autoComplete: "new-password" }}
            />
          </CustomerFormControl>
        </div>

        <br />
        <br />

        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={valueAba} onChange={handleChange}>
              {customer.customer?.customerServices?.map(
                (customerService, index) => {
                  return (
                    <Tab
                      key={index + 1201}
                      label={customerService.service.healthPlace.name}
                    />
                  );
                }
              )}
            </Tabs>
          </Box>
          {customer &&
            customer?.customer?.customerServices?.map(
              (customerService, index) => (
                <TabPanel key={index + 5452} value={valueAba} index={index}>
                  <ModalP>
                    <ModalB>Empresa:&nbsp;</ModalB>
                    {customerService.service.healthPlace.corporateName || "-"}
                  </ModalP>
                  <ModalP>
                    <ModalB>CNPJ:&nbsp;</ModalB>
                    {cnpjMask(customerService.service.healthPlace.cnpj) || "-"}
                  </ModalP>
                  <ModalP>
                    <ModalB>Data de Inclusão:&nbsp;</ModalB>
                    {DateFormat(customer.createdAt)}
                  </ModalP>
                  <ModalP>
                    <ModalB>Data de última modificação:&nbsp;</ModalB>
                    {DateFormat(customer.updatedAt)}
                  </ModalP>
                  <ModalP>
                    <ModalB>Medições Histórico:&nbsp;</ModalB>
                    {customerService.usedCurrentMonth || "-"}
                  </ModalP>
                </TabPanel>
              )
            )}
          {/* Medições Contratadas moved above; leave this area for tabs and details */}
        </Box>
        <CustomerContentButton>
          <CustomerButton title="Salvar">Salvar</CustomerButton>
        </CustomerContentButton>
      </CustomerForm>
    </CenteredPageDiv>
  );
};

export default CustomerEditComponent;
